import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import type { ArchivedBannerModel } from "../../utils/archivedBanner";
import { formatImportDate } from "./importText";
import styles from "./ImportBanners.module.css";

type ArchivedBannerProps = {
  model: ArchivedBannerModel | null;
  historyState?: "loading" | "failed" | "ready";
  onRetry?: () => void;
};

function separatorBefore(index: number, count: number): string {
  if (index === 0) return "";
  return index === count - 1 ? " and " : ", ";
}

/** Shown on an archived BPA's page: that it is archived, and where and when its content went. */
export function ArchivedBanner({ model, historyState = "ready", onRetry }: ArchivedBannerProps) {
  return (
    <div className={`${styles.banner} ${styles.archived}`} data-bpa-banner="">
      <div className={styles.text}>
        <strong>This practice area has been archived.</strong>
        <span>Content is no longer publishable and is hidden from the website.</span>
        {historyState === "loading" && <span>Loading where its content went...</span>}
        {historyState === "failed" && (
          <span role="alert">
            Where its content went couldn't be loaded.{" "}
            {onRetry && (
              <button type="button" className={styles.dismiss} onClick={onRetry}>
                Retry
              </button>
            )}
          </span>
        )}
        {historyState === "ready" && model && (
          <span>
            {model.lead}{" "}
            {model.targets.map((target, index) => (
              <Fragment key={target.bpaId}>
                {separatorBefore(index, model.targets.length)}
                <Link to={ROUTES.research.cmsBpa(target.editionId, target.bpaId)}>
                  {target.label}
                </Link>
              </Fragment>
            ))}{" "}
            on {formatImportDate(model.createdAt)}.
          </span>
        )}
      </div>
    </div>
  );
}
